import { Button, type ButtonProps } from "@ui-kit/Button";
import { CollapsibleTrigger } from "ics-ui-kit/components/collapsible";

export type CollapsibleButtonTriggerProps = Omit<ButtonProps, "endIcon"> & { open: boolean };

/**
 * The trigger of a collapsible, as a button.
 *
 * `CollapsibleTrigger` is an unstyled Radix re-export: used on its own it renders a bare `<button>`
 * with no hover, no focus ring and nothing to say it can be pressed. Every place in the product that
 * needed one has styled it again by hand, so this is that styling in one place — the disclosure
 * chevron follows `open`, and everything else is an ordinary button.
 */
export const CollapsibleButtonTrigger = ({ open, children, ...props }: CollapsibleButtonTriggerProps) => (
	<CollapsibleTrigger asChild>
		<Button
			className="h-auto p-0 font-normal text-muted-foreground"
			endIcon={open ? "chevron-up" : "chevron-down"}
			variant="text"
			{...props}
		>
			{children}
		</Button>
	</CollapsibleTrigger>
);
